<template>
  <div class="layout-activity">
    <div class="layout-activity-head">
      <a href="javascript:void(0);" @click="routeBack" class="layout-activity-back">
        <Icon type="md-arrow-back"></Icon>
      </a>
      <a href="javascript:void(0);" @click="routeClose" class="layout-activity-close">
        <Icon type="md-home"></Icon>
      </a>
      <div class="layout-activity-icons">
        <slot name="icons"></slot>
      </div>
      <h2>{{title}}</h2>
    </div>
    <div class="layout-activity-inner">
      <div class="layout-activity-image">
        <slot name="slogan"></slot>
      </div>
      <Spin v-if="spinShow || $store.state.loadingState" class="spin">
        <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
        <div>Loading</div>
      </Spin>
      <Tabs name="contentTabs" type="card" class="layout-activity-tabs" :animated="false" :value="value" @on-click="tabsChange">
        <template v-for="(tab, key) in tabs">
          <TabPane :label="tab.title" :key="key" :name="tab.key" v-if="tab.visible" :disabled="tab.disabled">
            <slot :name="tab.key"></slot>
          </TabPane>
        </template>
      </Tabs>
    </div>
    <slot name="other"></slot>
    <!-- <div class="children-activity">
      <keep-alive>
        <transition
          enter-active-class="animated slide-enter-active"
          leave-active-class="animated slide-leave-active"
          >
            <router-view></router-view>
        </transition>
      </keep-alive>
    </div> -->
  </div>
</template>

<script>
  export default {
    name: 'ContentLayout',
    props: {
      headBlur: {
        default: true
      },
      title: String,
      isChildren: Boolean,
      value: String,
      spinShow: {
        default: false
      },
      headImage: String,
      headBg: String,
      tabs: Array
    },
    components: {
    },
    data () {
      return {
        isDisabled: false
      }
    },
    watch: {
    },
    created () {
      // this.$store.dispatch('setMaskShow', true)
    },
    mounted () {
    },
    destroyed () {
      this.$store.dispatch('setMaskShow', false)
    },
    methods: {
      routeBack () {
        this.$router.go(-1)
      },
      routeClose () {
        this.$router.replace({'path': '/'})
      },
      tabsChange (val) {
        // this.spin_show = true
        this.$router.push({'path': val})
        this.$emit('input', val)
        // setTimeout(() => {
        //   this.spin_show = false
        // }, 2000)
      }
    }
  }
</script>

<style>
  .spin{
    padding: 10px 0;
    position:absolute;z-index:10;left:50%;width:100px;margin-left:-50px;
    background: #fff;
    box-shadow: 0 0 10px rgba(0,0,0,.4);
    border-radius: 0 0 4px 4px;
  }
  .ivu-tabs-tab-active{
    background-color: #fff;
    /*border-radius: 4px 4px 0 0*/
  }
  .children-activity{
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  .layout-activity-image{
    height: 90px;
    background-color: #333;
    position: relative;
  }
  .layout-activity-image .bg{height:100%;overflow: hidden;}
  .layout-activity-image .bg span{
    width:100%;
    height: 100%;
    display: block;
    background-repeat: no-repeat;
    background-size: auto 100%;
    background-position: center;
  }
  .layout-blur{
    background-size: cover !important;
    background-position: top center !important;
    /*opacity: .6;*/
    -webkit-transform: scale(1.2);
    transform: scale(1.2);
    -webkit-filter: blur(10px);
    filter: blur(10px);
  }
  .layout-activity-tabs{
    width:100%;
    margin-top: -31px;
  }
  .layout-activity-tabs .ivu-tabs-bar{margin-bottom: 0;}
  .layout-activity-tabs .ivu-tabs-nav-container{padding-left: 20px;}
  .layout-activity-head{
    text-align: center;
    background-color: rgba(0,0,0,.2);
    position: absolute;
    width: 100%;
    min-width: 1000px;
    height: 44px;
    top: 0;
    left: 0;
    z-index: 20;
  }
  .layout-activity-head h2{
    padding: 10px;
    font-size:16px;
    color: #fff;
  }
  .layout-activity{
    width: 90%;
    height: 100%;
    min-width: 1000px;
    position: fixed;
    z-index: 1;
    right: 0;
    top: 0;
    background-color: #fff;
  }
  .layout-activity .ivu-tabs-content{
    height: calc(100vh - 90px);
    overflow-y: scroll;
  }
  .layout-activity-inner{
    width: 100%;
    /* height: 100%; */
    min-width: 1000px;
    /* position: absolute; */
    /* top: 0; */
    /* left: 0; */
    overflow: hidden;
    /* overflow-y: auto; */
    /* padding-bottom: 40px; */
  }
  .layout-activity-inner .ivu-tabs{
    overflow: visible;
  }
  .layout-activity-back,
  .layout-activity-close{
    width: 40px;
    height: 100%;
    padding: 10px 15px;
    float: left;
    font-size: 18px;
    color: #fff;
    position: relative;
    z-index: 10;
  }
  .layout-activity-close{
    float: right;
  }
  .layout-activity-icons{
    float: right;
    padding: 10px 15px;
  }
  .layout-icon{
    background: none;
    border: none;
  }
  @media (max-width: 640px) {
    .layout-activity-inner,.layout-activity,.layout-activity-head{
      width: 100%;
      min-width: auto;
    }
  }
</style>
